import { AlbumsDataProps } from '@/types/albumsProps'
import { Input } from '../form/Input'
import { useForm } from 'react-hook-form'
import { Button } from '../Button'
import { useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'
import { handleSetAlbums } from '@/storage/modules/albums/reducer'
import { useToast } from '@/hooks/useToast'
import { useModal } from '@/hooks/useModal'
import { api } from '@/services/api'
import { notifyAlbumsUpdated } from '@/services/albumsEvents'

interface FormAlbumProps {
  isExist?: AlbumsDataProps
}

export function FormAlbum({ isExist }: FormAlbumProps) {
  const { register, handleSubmit, setValue } = useForm<AlbumsDataProps>()

  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()
  const { showToast } = useToast()
  const { closeModal } = useModal()

  const handleSaveNewAlbum = async (data: AlbumsDataProps) => {
    await api
      .post('/albums', data)
      .then(async () => {
        showToast('Album added successfully', {
          type: 'success',
          theme: 'light',
        })

        const responseAlbums = await api
          .get('/albums')
          .then((res) => res.data.data as AlbumsDataProps[])
        dispatch(handleSetAlbums({ albums: responseAlbums }))
        notifyAlbumsUpdated()

        setIsLoading(false)
        closeModal()
      })
      .catch((err) => {
        const errResponse = err.response.data
        setIsLoading(false)
        showToast(`${errResponse.message}`, {
          type: 'error',
          theme: 'light',
        })
      })
  }

  const handleEditAlbum = async (data: AlbumsDataProps, id: string) => {
    await api
      .patch(`/albums/${id}`, data)
      .then(async () => {
        showToast('Album edited successfully', {
          type: 'success',
          theme: 'light',
        })

        const responseAlbums = await api
          .get('/albums')
          .then((res) => res.data.data as AlbumsDataProps[])
        dispatch(handleSetAlbums({ albums: responseAlbums }))
        notifyAlbumsUpdated()

        setIsLoading(false)
        closeModal()
      })
      .catch((err) => {
        const errResponse = err.response.data
        setIsLoading(false)
        showToast(`${errResponse.message}`, {
          type: 'error',
          theme: 'light',
        })
      })
  }

  const onSubmit = (data: AlbumsDataProps) => {
    setIsLoading(true)

    if (isExist) {
      handleEditAlbum(data, isExist.id)
    } else {
      handleSaveNewAlbum(data)
    }
  }

  useEffect(() => {
    if (isExist) {
      setValue('title', isExist.title)
    }
  }, [isExist, setValue])

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Input
          placeholder="Digit album title"
          label="Album Title"
          name="title"
          register={register}
          required
        />
        <Button
          title={isExist ? 'Edit' : 'Save'}
          variant="purple"
          isLoading={isLoading}
        />
      </form>
    </div>
  )
}
